


















































import { apiPageConfigGetStateContentByApp } from '@/api'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useHandler, useQuery } from '@/hooks'
import { globalModel } from '@/model'
import { redirectTo } from '@/router'
import { Track } from '@/utils'
import { XWaterfallLoad } from '@/components'

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '支付成功',
        }))
      }

      loading = computed(() => false)

      query = useQuery<{
        orderNo: string
      }>()

      handleServiceClick = useHandler<'查看订单' | '返回首页'>({
        查看订单: () => redirectTo('BookOrderIndex'),
        返回首页: () =>
          dcb.navigateTo({
            url: globalModel.state.bizHomeUrl,
          }),
      })

      handleLoad: XWaterfallLoad = ({ pageNumber }) => {
        return apiPageConfigGetStateContentByApp({
          // TODO: 需资源位 ID
          stateId: '8aaa85a880c17f710180da796b8a01a7',
          pageIndex: pageNumber,
          pageSize: 10,
        }) as any
      }
    },
)
